import React from 'react';
import { PlcImg } from '@components/PlcImg/PlcImg.component';
import { Text } from '@components/Text/Text.component';
import { PlcAnchor } from '@layout/components/PlcAnchor/PlcAnchor.component';
import { ImageSrc } from '@utils/images';
import { urlEnum } from '@utils/url';

import './MeteoOthersTools.scss';

export const MeteoOthersTools = () => {
  const blocks: { i18n: string; image: ImageSrc; url: string }[] = [
    {
      i18n: 'meteo.othersTools-link.description-1',
      image: 'allie-1',
      url: urlEnum.productionDesPrairies,
    },
    {
      i18n: 'meteo.othersTools-link.description-2',
      image: 'allie-1',
      url: urlEnum.personnalisationMeteo,
    },
  ];

  return (
    <section className="othersTools-link wrapper-s plc-mb-l plc-mb-up-m-xxl">
      <Text className="plc-mb-basis" i18nKey="meteo.othersTools-link.title" tag="p" variant="p-style-h3" />
      <div className="othersTools-link-descriptions plc-mb-s plc-mb-up-m-m">
        {blocks.map(block => (
          <PlcAnchor key={block.i18n} linkProps={{ href: block.url }}>
            <div className="othersTools-link-description flex align-center plc-mb-m">
              <PlcImg alt="" plcSrc={{ src: block.image, type: 'local' }} />
              <Text className="plc-ml-m" i18nKey={block.i18n} tag="p" variant="h5" />
            </div>
          </PlcAnchor>
        ))}
      </div>
    </section>
  );
};
